import { WolfReef } from './WolfReef';

export default WolfReef;